import React from "react";

const HomeWorthCalculatorPage = () => {
  const features = [
    {
      title: "Accurate Valuation Data",
      description:
        "Housing.in employs automated home-value tools and MLS to provide precise data on homes sold or listed in your area.",
      icon: "/legal.png",
    },
    {
      title: "Expert Backed Data",
      description:
        "Our real estate professionals analyze features like amenities, location, and configuration to give a precise selling price.",
      icon: "/expert.png",
    },
    {
      title: "Easy Price Estimates",
      description:
        "Sellers can check similar homes in their area, and buyers can view last-deal values on our website for accurate comparisons.",
      icon: "/shortlist.png",
    },
    {
      title: "In-Person Evaluation",
      description:
        "Get in touch with our advisors for a detailed property evaluation to quote the most competitive selling price.",
      icon: "/sitevisits.png",
    },
  ];

  const impactStats = [
    {
      value: "₹100 Cr+",
      description: "Accurate Valuations Delivered",
      icon: "/deals.png",
    },
    {
      value: "10,000+",
      description: "Properties Evaluated Monthly",
      icon: "/shortlist.png",
    },
    {
      value: "5,000+",
      description: "Satisfied Sellers Every Month",
      icon: "/expert.png",
    },
  ];

  return (
    <div className="p-6 bg-gray-50">
      {/* Header Section */}
      <header className="text-center py-6">
        <h1 className="text-4xl font-bold text-gray-800">
          Get an Instant <span className="text-blue-600">Home Value Estimate</span>
        </h1>
        <p className="text-gray-600 mt-3 text-lg">
          How We Calculate the Selling Price for Your Property
        </p>
      </header>

      {/* Features Section */}
      <section className="my-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white shadow-lg rounded-lg p-6 flex flex-col items-center text-center border-t-4 border-blue-500 hover:shadow-xl transition duration-300"
            >
              <img
                src={feature.icon}
                alt={feature.title}
                className="w-16 h-16 mb-4"
              />
              <h3 className="text-xl font-bold text-gray-800">{feature.title}</h3>
              <p className="text-gray-600 mt-2">{feature.description}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Impact Section */}
      <section className="my-12">
        <h2 className="text-2xl font-bold text-gray-800 text-center mb-6">
          Why Choose Housing.in?
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {impactStats.map((stat, index) => (
            <div
              key={index}
              className="bg-white shadow-lg rounded-lg p-6 flex flex-col items-center text-center border-t-4 border-blue-500 hover:shadow-xl transition duration-300"
            >
              <img
                src={stat.icon}
                alt={stat.description}
                className="w-16 h-16 mb-4"
              />
              <h3 className="text-3xl font-bold text-blue-600">{stat.value}</h3>
              <p className="text-gray-600 mt-2">{stat.description}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default HomeWorthCalculatorPage;
